var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapacity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/capacity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Impact",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Impact-Section",
    transform: "translate(-524.000000, -180.000000)",
    fill: "#8C8C8C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Content",
    transform: "translate(267.500000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Statistic-Card",
    transform: "translate(232.500000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Statistic",
    transform: "translate(22.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/capacity",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C3.13132422,0 0,3.13077734 0,7 C0,10.8687031 3.13077734,14 7,14 C10.8686758,14 14,10.8692227 14,7 C14,3.13129688 10.8692227,0 7,0 Z M7,13.1796875 C4.87465234,13.1796875 2.97847266,12.11175 1.84942187,10.4179688 L12.1505508,10.4179688 C11.0185195,12.1162344 9.12023437,13.1796875 7,13.1796875 Z M1.38960938,9.59765625 C1.01699609,8.79405078 0.8203125,7.9121875 0.8203125,7 C0.8203125,3.58471094 3.58416406,0.8203125 7,0.8203125 C10.4152891,0.8203125 13.1796875,3.58416406 13.1796875,7 C13.1796875,7.9121875 12.9830039,8.79405078 12.6103906,9.59765625 L1.38960938,9.59765625 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5769453,3.42302734 C10.416793,3.26284766 10.157082,3.26284766 9.99690234,3.42302734 L7.63180469,5.788125 C7.44269531,5.68914063 7.22785547,5.6328125 7,5.6328125 C6.24613281,5.6328125 5.6328125,6.24613281 5.6328125,7 C5.6328125,7.75386719 6.24613281,8.3671875 7,8.3671875 C7.75386719,8.3671875 8.3671875,7.75386719 8.3671875,7 C8.3671875,6.77214453 8.31085937,6.55730469 8.21184766,6.36819531 L10.5769453,4.00307031 C10.737125,3.84289063 10.737125,3.58320703 10.5769453,3.42302734 Z M7,7.546875 C6.69845313,7.546875 6.453125,7.30154688 6.453125,7 C6.453125,6.69845313 6.69845313,6.453125 7,6.453125 C7.30154688,6.453125 7.546875,6.69845313 7.546875,7 C7.546875,7.30154688 7.30154688,7.546875 7,7.546875 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7,
    cy: 2.3515625,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.71300781,
    cy: 3.71300781,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.3515625,
    cy: 7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11.6484375,
    cy: 7,
    r: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacity);
export default __webpack_public_path__ + "static/media/capacity.eb8ef96884cc8b12278147c012963241.svg";
export { ForwardRef as ReactComponent };